import React, { useEffect } from "react";
import TextInput from "../Components/Inputs/TextInput";
import { Form, Formik, FormikHelpers } from "formik";
import { useState } from "react";
import { updatePersonProfileValidationSchema } from "utils/validationSchemas";
import apiLibrary from "services/api";
import { motion } from "framer-motion";
import { getUserProfileAction } from "store/userProfile";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { UserProfileState } from "store/userProfile/initialState";
import { Toasts } from "view/components/Toasts";
import Roles from "hooks/roles";
import { updateAuthDataAction } from "store/auth/reducer.actions";
import { Header } from "Components/Profile/components";
import {
  ContactDetails,
  DynamicEmailAndPhoneContainer,
} from "Components/Profile/Person";
import Addresses from "Components/Profile/Person/Addresses";
import moment from "moment";
import { DATE_FORMATS } from "constants/dateFormats";

import ellipsize from "ellipsize";
import { getRandomProgress } from "utils/getRandomProgress";
import { setLoadingProgress } from "store/loadingBar";
import MultiSelect from "./Components/MultiSelect";
export const Person = () => {
  const [isDivActive, setIsDivActive] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isMyProfile } = Roles();
  const [skipperScienceInputs, setSkipperScienceInputs] = useState(false);

  const tenYearsAgo = moment()
    .subtract(10, "years")
    .format(DATE_FORMATS.DEFAULT);

  const dispatch = useDispatch();
  const userProfile = useSelector<RootState, UserProfileState>(
    (state) => state?.userProfile
  );
  const [inputValue, setInputValue] = useState({
    position: "",
    gearType: "",
    fishery: "",
    engageWithFishery: "",
    tendor: "",
  });
  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: FormikHelpers<any>
  ) => {
    dispatch(setLoadingProgress(getRandomProgress()));
    try {
      const {
        position,
        gearType,
        fishery,
        fisheriesEngagementWay,
        tender,
        homePort,
        otherFishery,
        otherTender,
        ...restValues
      } = values;
      const formValues = {
        ...restValues,
        secondaryEmail: values.secondaryEmail.filter(
          (item: any) => !item.isPrimary && item.email !== ""
        ),
        secondaryPhoneNumber: values.secondaryPhoneNumber.filter(
          (item: any) => !item.isPrimary && item.phoneNumber !== ""
        ),
        ...(skipperScienceInputs && {
          position: position?.map((item: any) => item?.value),
          gearType: gearType?.map((item: any) => item?.value),
          fishery: fishery?.map((item: any) => item?.value),
          fisheriesEngagementWay: fisheriesEngagementWay?.map(
            (item: any) => item.value
          ),
          tender: tender?.map((item: any) => item.value),
          homePort: homePort,
          otherTender: otherTender,
          otherFishery: otherFishery,
        }),
      };
      const { data, message } = await apiLibrary.userProfile.updateUserProfile(
        userProfile.personId,
        formValues
      );
      if (isMyProfile(data?.personId)) {
        dispatch(updateAuthDataAction(data));
      }
      if (data) {
        dispatch(getUserProfileAction(data));
      }
      Toasts.success(message);
      resetForm();
      setEditMode(false);
    } catch (error: any) {
      console.error(error);
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);
    } finally {
      setSubmitting(false);
      dispatch(setLoadingProgress(100));
    }
  };

  const handleEditPerson = () => {
    setEditMode(!editMode);
    setIsDivActive(!isDivActive);
  };

  const updatePersonData = async (values: any) => {
    dispatch(setLoadingProgress(getRandomProgress()));
    try {
      setIsLoading(true);
      const {
        position,
        gearType,
        fishery,
        fisheriesEngagementWay,
        tender,
        homePort,
        otherFishery,
        otherTender,
        ...restValues
      } = values;
      const formValues = {
        ...restValues,
        secondaryEmail: values.secondaryEmail.filter(
          (item: any) => !item.isPrimary && item.email !== ""
        ),
        secondaryPhoneNumber: values.secondaryPhoneNumber.filter(
          (item: any) => !item.isPrimary && item.phoneNumber !== ""
        ),
        ...(skipperScienceInputs && {
          position: position?.map((item: any) => item?.value),
          gearType: gearType?.map((item: any) => item?.value),
          fishery: fishery?.map((item: any) => item?.value),
          fisheriesEngagementWay: fisheriesEngagementWay?.map(
            (item: any) => item.value
          ),
          tender: tender?.map((item: any) => item.value),
          homePort: homePort,
          otherTender: otherTender,
          otherFishery: otherFishery,
        }),
      };

      const { data, message } = await apiLibrary.userProfile.updateUserProfile(
        userProfile.personId,
        formValues
      );
      if (isMyProfile(data?.personId)) {
        dispatch(updateAuthDataAction(data));
      }

      dispatch(getUserProfileAction(data));

      Toasts.success(message);
    } catch (error: any) {
      console.error(error);
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);
    } finally {
      dispatch(setLoadingProgress(100));
      setIsLoading(false);
    }
  };

  const positionsData = [
    {
      value: "Skipper",
      label: "Skipper",
    },
    {
      value: "Deckhand",
      label: "Deckhand",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  const gearTypeData = [
    {
      value: "Gillnet",
      label: "Gillnet",
    },
    {
      value: "Seine",
      label: "Seine",
    },
    {
      value: "Troll",
      label: "Troll",
    },
    {
      value: "Pot",
      label: "Pot",
    },
    {
      value: "Longline",
      label: "Longline",
    },
    {
      value: "Highline",
      label: "Highline",
    },
    {
      value: "Drift net",
      label: "Drift net",
    },
    {
      value: "Set net",
      label: "Set net",
    },
    {
      value: "Dip net",
      label: "Dip net",
    },
    {
      value: "Dive",
      label: "Dive",
    },
    {
      value: "Rod and reel",
      label: "Rod and reel",
    },
    {
      value: "Ring net",
      label: "Ring Net",
    },
    {
      value: "Handline",
      label: "Handline",
    },
    {
      value: "By hand",
      label: "By hand",
    },
    {
      value: "Gaff",
      label: "Gaff",
    },
    {
      value: "Spear",
      label: "Spear",
    },
    {
      value: "Cast net",
      label: "Cast net",
    },
    {
      value: "Trawl",
      label: "Trawl",
    },
    {
      value: "Halibut hook",
      label: "Halibut hook",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  const fisheriesData = [
    {
      value: "Salmon",
      label: "Salmon",
    },
    {
      value: "Black Cod (sablefish)",
      label: "Black Cod (sablefish)",
    },
    {
      value: "Crab",
      label: "Crab",
    },
    {
      value: "Shrimp",
      label: "Shrimp",
    },
    {
      value: "Lingcod",
      label: "Lingcod",
    },
    {
      value: "Rockfish",
      label: "Rockfish",
    },
    {
      value: "Halibut",
      label: "Halibut",
    },
    {
      value: "Pacific Cod",
      label: "Pacific Cod",
    },
    {
      value: "Herring",
      label: "Herring",
    },
    {
      value: "Turbot",
      label: "Turbot",
    },
    {
      value: "Squid",
      label: "Squid",
    },
    {
      value: "Scallop",
      label: "Scallop",
    },
    {
      value: "Mackerel",
      label: "Mackerel",
    },
    {
      value: "Pollock",
      label: "Pollock",
    },
    {
      value: "Sole",
      label: "Sole",
    },
    {
      value: "Oyster",
      label: "Oyster",
    },
    {
      value: "Mussel",
      label: "Mussel",
    },
    {
      value: "Kelp",
      label: "Kelp",
    },
    {
      value: "Sea Cucumbers",
      label: "Sea Cucumbers",
    },
    {
      value: "Geoduck",
      label: "Geoduck",
    },
    {
      value: "Clam",
      label: "Clam",
    },
    {
      value: "Abalone",
      label: "Abalone",
    },
    {
      value: "Skates",
      label: "Skates",
    },
    {
      value: "Sculpin",
      label: "Sculpin",
    },
    {
      value: "Grenadier",
      label: "Grenadier",
    },
    {
      value: "Krill",
      label: "Krill",
    },
    {
      value: "Flatfish",
      label: "Flatfish",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  const engageWithFisheriesData = [
    {
      value: "Commercial",
      label: "Commercial",
    },
    {
      value: "Recreational",
      label: "Recreational",
    },
    {
      value: "Subsistence",
      label: "Subsistence",
    },
  ];

  const workWithTendorsData = [
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  useEffect(() => {
    let skipperApp = userProfile.usedApps.some(
      (item) => item.id === "skipper_science"
    );
    if (skipperApp) {
      setSkipperScienceInputs(skipperApp);
    } else {
      setSkipperScienceInputs(skipperApp);
    }
  }, [userProfile.usedApps]);

  return (
    <div className="flex flex-col items-start self-stretch justify-start flex-grow pb-8 overflow-hidden border-t-0 border-b-0 border-l border-r-0 border-lineMid dark:border-lineLight dark:bg-secondaryLight">
      <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 overflow-hidden bg-white">
        <Formik
          initialValues={userProfile}
          validationSchema={updatePersonProfileValidationSchema}
          enableReinitialize={true}
          onSubmit={handleSubmit}
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            resetForm,
            isSubmitting,
            setFieldValue,
          }) => {
            useEffect(() => {
              const hasOther = (arr: any[]) =>
                arr?.some((item) => item?.value === "Other");

              if (!hasOther(values.fishery)) {
                setFieldValue("otherFishery", "");
              }

              if (!hasOther(values.tender)) {
                setFieldValue("otherTender", "");
              }
            }, [values.fishery, values.tender]);

            useEffect(() => {
              const hasOther = (arr: any[]) =>
                arr?.some((item) => item?.value === "Other");

              if (hasOther(values.fishery)) {
                setFieldValue("otherFishery", userProfile.otherFishery);
              }

              if (hasOther(values.tender)) {
                setFieldValue("otherTender", userProfile.otherTender);
              }
            }, [editMode]);
            return (
              <Form className={`dark:bg-secondaryLight w-full`}>
                <Header
                  title="Personal Info"
                  editMode={editMode}
                  handleEdit={handleEditPerson}
                  resetForm={resetForm}
                  isSubmitting={isSubmitting}
                />
                <div
                  className={`w-full relative border-b border-l-0 border-t-0 border-r-0 border-lineMid dark:border-lineLight pb-16`}
                >
                  {/* {isSubmitting && <Overlay />} */}
                  <div className="flex flex-col w-full px-8 pt-4 pb-12 xl:px-12 ">
                    <div className="flex flex-col w-full ">
                      <div
                        className={`grid ${
                          editMode
                            ? "xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-1"
                            : "xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1"
                        } gap-4`}
                      >
                        <div className="flex flex-col flex-wrap flex-grow w-full break-all rounded-lg">
                          <TextInput
                            label={editMode ? "First name*" : "First name"}
                            type="text"
                            name="firstName"
                            setFieldValue={setFieldValue}
                            error={errors?.firstName}
                            editMode={editMode}
                            value={values?.firstName}
                            touched={touched.firstName}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                          />
                        </div>
                        <div className="flex flex-col flex-grow w-full break-all rounded-lg">
                          <TextInput
                            label={editMode ? "Last name*" : "Last name"}
                            type="text"
                            name="lastName"
                            setFieldValue={setFieldValue}
                            error={errors?.lastName}
                            editMode={editMode}
                            value={values?.lastName}
                            touched={touched.lastName}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <motion.div
                      animate={{
                        translateY: editMode ? 20 : 0,
                      }}
                      className={`grid relative z-20 ${
                        editMode
                          ? "xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-1"
                          : "xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1"
                      } gap-4 mt-[-10px] `}
                    >
                      <div className="flex flex-col flex-grow mt-2">
                        {/* {skipperScienceInputs ? ( */}
                        <TextInput
                          height={37.5}
                          label="Birthday"
                          type="date"
                          name="dateOfBirth"
                          inputClassName=""
                          setFieldValue={setFieldValue}
                          error={errors?.dateOfBirth}
                          editMode={editMode}
                          value={
                            values?.dateOfBirth
                              ? values.dateOfBirth.toString()
                              : ""
                          }
                          touched={touched.dateOfBirth}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          max={tenYearsAgo}
                        />
                      </div>
                      <div className="flex flex-col flex-grow rounded-lg mt-2">
                        <TextInput
                          label="Suffix"
                          type="text"
                          name="suffix"
                          setFieldValue={setFieldValue}
                          error={errors?.suffix}
                          editMode={editMode}
                          // value={splitString(values?.suffix,30)}
                          value={ellipsize(values?.suffix, 30)}
                          touched={touched.suffix}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                        />
                      </div>
                      {skipperScienceInputs && (
                        <>
                          <div
                            className={`flex items-start justify-start w-full`}
                          >
                            <MultiSelect
                              label={"Position"}
                              name={"position"}
                              editMode={editMode}
                              inputValue={inputValue.position}
                              onInputChange={(value: string) => {
                                setInputValue((prev) => ({
                                  ...prev,
                                  position: value,
                                }));
                                // Optional: handleEntitiesSearch(value);
                              }}
                              options={positionsData}
                              defaultValue={{ value: "", label: "" }}
                              isMulti={true}
                              placeholder="Select"
                              closeOnSelect={false}
                              handleBlur={handleBlur}
                              value={values?.position}
                              className={"border border-lineDark rounded-md"}
                              onChange={(option: any) => {
                                setFieldValue("position", option);
                              }}
                            />
                          </div>
                          <div className={`flex items-start justify-start w-full`}>
                            <MultiSelect
                              label={"Gear Type"}
                              name={"gearType"}
                              editMode={editMode}
                              inputValue={inputValue.gearType}
                              onInputChange={(value: string) => {
                                setInputValue((prev) => ({
                                  ...prev,
                                  gearType: value,
                                }));
                                // Optional: handleEntitiesSearch(value);
                              }}
                              options={gearTypeData}
                              defaultValue={{ value: "", label: "" }}
                              isMulti={true}
                              placeholder="Select"
                              closeOnSelect={false}
                              handleBlur={handleBlur}
                              value={values?.gearType}
                              className={"border border-lineDark rounded-md"}
                              onChange={(option: any) => {
                                setFieldValue("gearType", option);
                              }}
                            />
                          </div>
                          <div className={`flex items-start justify-start w-full`}>
                            <TextInput
                              label="Homeport(s)"
                              type="text"
                              name="homePort"
                              inputClassName=" placeholder:normal-case "
                              setFieldValue={setFieldValue}
                              error={errors?.homePort}
                              placeholder={"Homeport(s)"}
                              editMode={editMode}
                              value={values?.homePort}
                              touched={touched.homePort}
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                            />
                          </div>
                          <div className={`flex items-start justify-start w-full`}>
                            <MultiSelect
                              label={"Fishery(s)"}
                              name={"fishery"}
                              editMode={editMode}
                              inputValue={inputValue.fishery}
                              onInputChange={(value: string) => {
                                setInputValue((prev) => ({
                                  ...prev,
                                  fishery: value,
                                }));
                                // Optional: handleEntitiesSearch(value);
                              }}
                              options={fisheriesData}
                              defaultValue={{ value: "", label: "" }}
                              isMulti={true}
                              placeholder="Fishery(s)"
                              closeOnSelect={false}
                              handleBlur={handleBlur}
                              value={values?.fishery}
                              className={"border border-lineDark rounded-md"}
                              onChange={(option: any) => {
                                setFieldValue("fishery", option);
                              }}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                              otherValue={values.otherFishery}
                            />
                          </div>
                          <div className={`flex items-start justify-start w-full`}>
                            <MultiSelect
                              label={
                                "In what ways do you engage with these fisheries?"
                              }
                              name={"fisheriesEngagementWay"}
                              editMode={editMode}
                              inputValue={inputValue.engageWithFishery}
                              onInputChange={(value: string) => {
                                setInputValue((prev) => ({
                                  ...prev,
                                  engageWithFishery: value,
                                }));
                                // Optional: handleEntitiesSearch(value);
                              }}
                              options={engageWithFisheriesData}
                              defaultValue={{ value: "", label: "" }}
                              isMulti={true}
                              placeholder="Select"
                              closeOnSelect={false}
                              handleBlur={handleBlur}
                              value={values?.fisheriesEngagementWay}
                              className={"border border-lineDark rounded-md"}
                              onChange={(option: any) => {
                                setFieldValue("fisheriesEngagementWay", option);
                              }}
                            />
                          </div>
                          <div className={`flex items-start justify-start w-full`}>
                            <MultiSelect
                              label={"Do you work on Tenders?"}
                              name={"tender"}
                              editMode={editMode}
                              inputValue={inputValue.tendor}
                              onInputChange={(value: string) => {
                                setInputValue((prev) => ({
                                  ...prev,
                                  tendor: value,
                                }));
                                // Optional: handleEntitiesSearch(value);
                              }}
                              options={workWithTendorsData}
                              defaultValue={{ value: "", label: "" }}
                              isMulti={false}
                              placeholder="Select"
                              closeOnSelect={false}
                              handleBlur={handleBlur}
                              value={values?.tender}
                              className={"border border-lineDark rounded-md"}
                              onChange={(option: any) => {
                                setFieldValue("tender", [option]);
                              }}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                              otherValue={values.otherTender}
                            />
                          </div>
                        </>
                      )}
                    </motion.div>
                    {editMode ? (
                      <>
                        <motion.div
                          animate={{
                            translateY: editMode ? 90 : 0,
                          }}
                          className="mt-[-40px] relative z-0"
                        >
                          <DynamicEmailAndPhoneContainer
                            values={userProfile}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            updatePersonData={updatePersonData}
                            isLoading={isLoading}
                          />
                        </motion.div>
                      </>
                    ) : (
                      <ContactDetails editMode={editMode} />
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        <Addresses addresses={userProfile?.addresses} />
      </div>
    </div>
  );
};

const Overlay = () => (
  <div
    className="cursor-progress"
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  ></div>
);
